import Vue from 'vue'
import DatetimePicker from '@goldenm/vuetify-datetime-picker'

import App from './App.vue'
import { sync } from 'vuex-router-sync'
import { i18n, vuetify, assets, router, store, apollo, orm, axios } from '@/plugins'
import * as Sentry from '@sentry/vue'
// Charts library
// import VueApexCharts from 'vue-apexcharts'

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@/assets/application.scss'

Sentry.init({
  Vue,
  dsn: 'https://97b049a5f6111717386a73de7f0a9570@o4510206789419008.ingest.de.sentry.io/4511254618177616',
  enabled: process.env.NODE_ENV === 'production',
  sendDefaultPii: true
})

// Vue.use(VueApexCharts)
Vue.use(DatetimePicker)

// Vue.component('apexchart', VueApexCharts)

Vue.use(assets)
Vue.use(orm)
Vue.use(axios)
// Vue.use(googlemaps)

// Vue.use(VueCodemirror)

sync(store, router)

new Vue({
  i18n,
  vuetify,
  router,
  store,
  apolloProvider: apollo,

  computed: {
    messages () {
      return this.$i18n.messages
    },
    routeParams () {
      return window.location.search
    }
  },

  watch: {
    $route (newVal) {
      document.title = `${this.$i18n.t(`pages.${newVal.name}`)} | ${this.$i18n.t('app.title')}`
    },

    messages () {
      document.title = `${this.$i18n.t(`pages.${this.$route.name}`)} | ${this.$i18n.t('app.title')}`
    }
  },

  beforeCreate () {
    this.$store.subscribe(mutation => {
      if (mutation.type === 'setAvailableLanguages') {
        const locale = localStorage.getItem('operative.current.locale.code')
        if (locale && locale !== 'undefined') {
          this.$i18n.locale = locale
        } else {
          const lang = navigator.language || navigator.userLanguage
          const check = mutation.payload.filter(item => item.code === lang)
          if (check.length === 0) {
            this.$i18n.locale = 'en-GB'
          } else {
            this.$i18n.locale = 'en-GB'
          }
        }

        this.$store.commit('setLanguage', this.$i18n.locale)
      }
    })

    this.$store.dispatch('languages/fetchI18n')
    window.addEventListener('resize', () => {
      if (this.$store.state.width.full !== window.innerWidth) {
        this.$store.commit('setWidth', window.innerWidth)
      }
    })
    // this.getSession()
    // this.$apollo.query({
    //   query: getApp,
    //   variables: {
    //     host: process.env.NODE_ENV === 'development' ? 'localhost' : window.location.hostname
    //   },
    //   fetchPolicy: 'no-cache'
    // }).then(async (response) => {
    //   const { status, result } = response.data.loadDeployedApp

    //   switch (status) {
    //     case 'OK':
    //       this.$vuetify.theme.themes.light.primary = result.designInformation.colors.primary
    //       this.$vuetify.theme.themes.light.secondary = result.designInformation.colors.secondary
    //       this.$vuetify.theme.themes.light.accent = result.designInformation.colors.accent
    //       this.$vuetify.theme.themes.dark.primary = result.designInformation.colors.primary
    //       this.$vuetify.theme.themes.dark.secondary = result.designInformation.colors.secondary
    //       this.$vuetify.theme.themes.dark.accent = result.designInformation.colors.accent
    //       this.$store.commit('setApp', result)
    //       await this.readLoginAsParams()
    //
    //       break

    //     case 'BADREQUEST':
    //       this.$store.commit('toggleSnackbar')
    //       break

    //     case 'NOTFOUND':
    //       this.$router.push('/NoApp')
    //       this.$store.commit('setLoading', false)
    //       break
    //   }
    // }).catch(() => {
    //   this.$store.commit('toggleSnackbar')
    // })

    const dark = localStorage.getItem('operative.dark.mode')
    if (dark !== undefined) {
      this.$store.commit('setDark', dark === 'true')
      this.$vuetify.theme.dark = dark === 'true'
    }
  },

  created () {
    const apiToken = localStorage.getItem('token.token')

    this.getSession()

    if (apiToken === undefined) {
      // this.$router.push('/Login')

      this.$store.commit('setLoading', false)
    }
  },

  mounted () {
    document.title = `${this.$i18n.t(`pages.${this.$route.name}`)} | ${this.$i18n.t('app.title')}`
    // this.$store.dispatch('getCountries')
    // this.$store.dispatch('getMeasureUnits')
  },

  beforeDestroy () {
    window.removeEventListener('resize')
  },

  methods: {
    getSession () {
      const apiToken = localStorage.getItem('token.token')
      if (apiToken !== undefined) {
        this.$store.dispatch('session/loadEntity')
      }
    }
  },

  render: h => h(App)
}).$mount('#app')
